import React, { Component, ErrorInfo, ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="flex flex-col items-center justify-center h-full p-6 text-center bg-red-50 dark:bg-red-900/20 rounded-xl border border-red-100 dark:border-red-800">
          <AlertTriangle className="w-8 h-8 text-red-500 mb-2" />
          <h3 className="font-bold text-red-700 dark:text-red-400">Bileşen Yüklenemedi</h3>
          <p className="text-xs text-red-600/80 dark:text-red-300/80 mt-1 max-w-[200px]">
            Bu grafik görüntülenirken bir sorun oluştu.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;